import * as React from 'react'

export const CaptableTableNew = () => {
    return <div>table</div>
}